import React, { useState, useEffect, useRef } from 'react';

import { formatTime } from '@utils/date';

interface DowntimeTimerProps {
  initialTime: number;
  resendOtp: () => void;
}

const DowntimeTimer: React.FC<DowntimeTimerProps> = ({
  initialTime,
  resendOtp
}) => {
  const [seconds, setSeconds] = useState<number>(initialTime);
  const [timerExpired, setTimerExpired] = useState<boolean>(false);
  const intervalIdRef = useRef<NodeJS.Timeout | null>(null);

  const resetTimer = () => {
    intervalIdRef.current = setInterval(() => {
      setSeconds((prevSeconds) => prevSeconds - 1);
    }, 1000);
  };

  const handleResendOtp = () => {
    resendOtp();
    setTimerExpired(false);
    setSeconds(initialTime);
    resetTimer();
  };

  useEffect(() => {
    resetTimer();
    // Cleanup interval when the component unmounts
    return () => {
      clearInterval(intervalIdRef.current!);
    };
  }, []);

  useEffect(() => {
    if (seconds === 0) {
      setTimerExpired(true);
      clearInterval(intervalIdRef.current!);
    }
  }, [seconds]);

  return (
    <div className="flex flex-col items-center text-sm font-normal lg:flex-row ">
      <span className="text-grey5">Didn’t receive OTP code?</span> {` `}
      {timerExpired ? (
        <div
          className="ml-1 cursor-pointer font-semibold text-grey5"
          role="presentation"
          onClick={handleResendOtp}
        >
          Resend OTP
        </div>
      ) : (
        <div className="ml-1 font-semibold text-grey5 ">
          Request a new code in {` `}
          <span className="font-semibold text-grey5">
            {formatTime(seconds)}
          </span>
        </div>
      )}
    </div>
  );
};

export default DowntimeTimer;
